import React, { useState } from "react";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddTicket from "../../Modals/addTicket";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AnalyticsIcon from '@mui/icons-material/Analytics';

interface SupportData {
    id: number;
    title: string;
    description: string;
    submittedDate: string;
    status: "Pending" | "Resolved";
    adminReply?: string;
}

const AdminSupport = () => {
    const navigate = useNavigate();
    const [subTab, setSubTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedRowStatus, setSelectedRowStatus] =
        useState<"Pending" | "Resolved">("Pending");

    const subTabs: ("Pending" | "Resolved")[] = ["Pending", "Resolved"];

    const [supportData, setSupportData] = useState<SupportData[]>([
        {
            id: 1,
            title: "App not loading",
            description: "The app freezes when I open it.",
            submittedDate: "20 Oct 2025",
            status: "Pending",
        },
        {
            id: 2,
            title: "Refund not processed",
            description: "I haven't received my refund yet.",
            submittedDate: "19 Oct 2025",
            status: "Resolved",
            adminReply: "Refund has been initiated and will reflect in 3–5 days.",
        },
        {
            id: 3,
            title: "Chat not connecting",
            description: "Unable to send or receive messages.",
            submittedDate: "18 Oct 2025",
            status: "Pending",
        },
    ]);

    const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSubTab(newValue);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    // Filter Data Based on Subtab
    const filteredData = supportData.filter(
        (item) => item.status === subTabs[subTab]
    );
    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };

    return (
        <>
            <div className="main_title">
                <h1>Admin Support Management </h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Admin Support Management
                </p>
            </div>
            <Box className="support_dashboard_cards">

                {/* TOP STATS */}
                <Box className="stats_row">
                    <div className="stat_card">
                        <p className="label">Active Tickets</p>
                        <h2 className="value">0</h2>
                    </div>

                    <div className="stat_card">
                        <p className="label">Resolved</p>
                        <h2 className="value">0</h2>
                    </div>

                    <div className="stat_card">
                        <p className="label">Avg Response Time</p>
                        <h2 className="value">~2h</h2>
                    </div>
                </Box>


                <ul className="add_campaign">
                    <li className="one" onClick={() => setOpenModal(true)}>
                        <AddIcon />
                        <h3>Create New Ticket</h3>
                        <p>Get help with an issue</p>
                    </li>
                    <li className="two" onClick={() => navigate("view")}>
                        <AnalyticsIcon />
                        <h3>View All Tickets</h3>
                        <p>Check status and replies</p>
                    </li>

                </ul>
                <div className="cards quick_help_section mt_20">
                    <h3 className="section_title">Quick Help Resources</h3>

                    <div className="quick_help_grid">
                        {/* Knowledge Base */}
                        <div className="quick_help_box cr_pt" onClick={()=> navigate("knowledge-base")}>
                            <div className="icon">
                                <img src="/static/images/book_icon.svg" alt="Knowledge Base" />
                            </div>
                            <div className="text">
                                <h4>Knowledge Base</h4>
                                <p>Browse articles and guides</p>
                            </div>
                        </div>

                        {/* Video Tutorials */}
                        <div className="quick_help_box cr_pt" onClick={()=> navigate("video-tutorial")}>
                            <div className="icon">
                                <img src="/static/images/video_icon.svg" alt="Video Tutorials" />
                            </div>
                            <div className="text">
                                <h4>Video Tutorials</h4>
                                <p>Learn with step-by-step videos</p>
                            </div>
                        </div>

                        {/* Email Support */}
                        <div className="quick_help_box">
                            <div className="icon">
                                <img src="/static/images/email_icon.svg" alt="Email Support" />
                            </div>
                            <div className="text">
                                <h4>Email Support</h4>
                                <p>support@boujeek.ae</p>
                            </div>
                        </div>

                        {/* Phone Support */}
                        <div className="quick_help_box">
                            <div className="icon">
                                <img src="/static/images/phone_icon.svg" alt="Phone Support" />
                            </div>
                            <div className="text">
                                <h4>Phone Support</h4>
                                <p>+971 4 444 3333</p>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="home_faq_sc mt_20">
                    <div className="container">
                        <div className="main_title">
                            <h1>Frequently asked questions</h1>
                        </div>
                        <div className="faq_lst hd_7">
                            {[
                                {
                                    q: "How can I place an order?",
                                    a: "Browse our products, add the items you want to your cart, and proceed to checkout. Enter your shipping details and payment information to complete your order.",
                                    id: "p1",
                                },
                                {
                                    q: "What payment methods are accepted?",
                                    a: "We accept credit/debit cards, PayPal, Apple Pay, and other secure payment methods. All transactions are encrypted for your safety.",
                                    id: "p2",
                                },
                                {
                                    q: "How do I track my order?",
                                    a: "Once your order is shipped, you will receive a tracking number via email. Use it on our website or the carrier’s site to monitor delivery status.",
                                    id: "p3",
                                },
                                {
                                    q: "Can I return or exchange a product?",
                                    a: "Yes, returns and exchanges are accepted within 30 days of delivery. Ensure the product is unused and in original packaging, and follow our return process online.",
                                    id: "p4",
                                },
                                {
                                    q: "Are there discounts or promotions available?",
                                    a: "We regularly offer discounts, seasonal promotions, and coupon codes. Check our homepage or subscribe to our newsletter for the latest deals.",
                                    id: "p5",
                                },
                                {
                                    q: "How do I contact customer support?",
                                    a: "You can reach our support team via live chat, email, or phone. Visit the “Contact Us” page for more details.",
                                    id: "p6",
                                },
                            ].map((item) => (
                                <Accordion
                                    key={item.id}
                                    expanded={expanded === item.id}
                                    onChange={handleChange(item.id)}
                                    className="faq_bx"
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <h3>{item.q}</h3>
                                    </AccordionSummary>
                                    <AccordionDetails>{item.a}</AccordionDetails>
                                </Accordion>
                            ))}
                        </div>
                    </div>
                </section>
                {/* QUICK HELP */}
                {/* <h3 className="section_title">Quick Help Resources</h3>

                <div className="help_grid">
                    <div className="help_card">
                        <h4>Knowledge Base</h4>
                        <p>Browse articles & guides</p>
                    </div>

                    <div className="help_card">
                        <h4>Video Tutorials</h4>
                        <p>Learn with step-by-step videos</p>
                    </div>

                    <div className="help_card">
                        <h4>Email Support</h4>
                        <p>support@cloudnest.ae</p>
                    </div>

                    <div className="help_card">
                        <h4>Phone Support</h4>
                        <p>+971 4 444 3231</p>
                    </div>
                </div> */}

            </Box>   {/* Sub Tabs */}


            {/* Add Reply Modal */}
            <AddTicket
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default AdminSupport;
